import React from 'react';

const Magnet = ({ width = 20, height = 20, color = 'var(--icon-default)', ...rest }, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg
      {...rest}
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.037 2.5H13.75C14.4403 2.5 15 3.05964 15 3.75V5C15 5.69036 14.4403 6.25 13.75 6.25H12.037M12.037 2.5H9.16662C5.02449 2.5 1.66663 5.85786 1.66663 10C1.66663 14.1421 5.02449 17.5 9.16663 17.5H12.037M12.037 2.5V6.25M12.037 6.25H9.12033C7.04926 6.25 5.37033 7.92893 5.37033 10C5.37033 12.0711 7.04926 13.75 9.12033 13.75H12.037M12.037 13.75H13.75C14.4403 13.75 15 14.3096 15 15V16.25C15 16.9404 14.4403 17.5 13.75 17.5H12.037M12.037 13.75V17.5"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.9166 5C17.9166 5 19.1666 6.5 19.1666 10C19.1666 13.5 17.9166 15 17.9166 15"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <path
        d="M16.25 7.5C16.25 7.5 16.6667 8.25 16.6667 10C16.6667 11.75 16.25 12.5 16.25 12.5"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default React.forwardRef(Magnet);
